export default __webpack_public_path__ + "static/media/Goremonger's Girdle.e91baeb3.jpg";